// src/redux/selectors/overdueActions.js

import { createSelector } from 'reselect';

// Selector to get saved control evaluations
const selectSavedControlEvaluations = (state) => state.controls.savedControlEvaluations;

// Selector to get saved controls
const selectSavedControls = (state) => state.controls.savedControls;

// Selector to get assessments (was: models)
const selectByAssessment = (state) => state.risks.byAssessment;

// Selector to compute overdue actions based on 'executedNext'
export const selectOverdueActions = createSelector(
  [selectSavedControlEvaluations, selectSavedControls, selectByAssessment],
  (savedControlEvaluations, savedControls, byAssessment) => {
    const today = new Date();
    const overdue = [];

    Object.entries(savedControlEvaluations).forEach(([riskId, controls]) => {
      Object.entries(controls).forEach(([controlId, evaluations]) => {
        evaluations.forEach((evaluation) => {
          const dueDateStr = evaluation.executed_next; // Using 'executedNext' as the due date field
          if (dueDateStr) {
            const dueDate = new Date(dueDateStr);
            // Compare dates (ignoring time)
            if (dueDate.setHours(0, 0, 0, 0) < today.setHours(0, 0, 0, 0)) {
              const control = savedControls[riskId]?.find(c => c.controlId === controlId);
              if (control) {
                // Try to find assessment by assessmentUuid or fall back to modelUuid
                const assessment = byAssessment[control.assessmentUuid] ||
                                   Object.values(byAssessment).find(a => a.modelId === control.modelUuid);
                const assessmentName = assessment?.assessmentName || assessment?.modelName || 'Unnamed Assessment';
                const riskName = control.riskName || 'Unnamed Risk';

                const owner = evaluation.control_owner || 'Unassigned';

                overdue.push({
                  id: control.controlId,
                  controlName: control.name,
                  dueDate: dueDateStr,
                  riskId,
                  riskName,
                  modelName: assessmentName, // Keep modelName for backward compatibility
                  assessmentName,
                  owner,
                });
              }
            }
          }
        });
      });
    });
    return overdue;
  }
);
